export default class ModalMenu {

    constructor($el) {
        this.$el = $el;
        this.$modal = this.$el.querySelector('[data-modal-account]');
        this.$mouseOver = false;


        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);

        this.$el.addEventListener('mouseover', this.showModal);
        this.$el.addEventListener('click', this.toggleModal);

        this.$modal.addEventListener('mouseover', (e) => {
            this.$mouseOver = true;
        })
        if(this.$modal !== null)
        {
            this.$modal.addEventListener('mouseleave', (e) => {
                this.$mouseOver = false;
                this.closeModal();
            });
            this.$el.addEventListener('mouseleave', (e) => {
                setTimeout(this.closeModal, 300);
            });
        }


    }

    showModal(e) {
        e.preventDefault();
        this.$modal.classList.add('modal--open');
    }

    closeModal() {
        if( ! this.$mouseOver) {
            this.$modal.classList.remove('modal--open');
        }
    }

    toggleModal(e) {
        if( ! this.$modal.classList.contains('modal--open')) {
            this.$modal.classList.add('modal--open');
            return;
        }
        this.$modal.classList.remove('modal--open');
    }

}